<!--
 * @Description: 订餐记录
 * @Autor: zczhang
 * @Date: 2021-03-15 09:16:00
 * @LastEditors: zczhang
 * @LastEditTime: 2021-03-15 14:07:34
-->
<template>
    <div class="dcDialog">
        <el-dialog
            :title="title"
            :visible="show"
            :destroy-on-close="true"
            :modal-append-to-body="false"
            :before-close="cancel"
        >
            <el-table :data="datas.table" border ref="dc_records_table">
                <el-table-column
                    label="序号"
                    width="80"
                    align="center"
                    type="index"
                ></el-table-column>
                <el-table-column
                    label="时间"
                    align="center"
                    prop="orderTime"
                ></el-table-column>
                <el-table-column
                    label="订餐方式"
                    align="center"
                    prop="orderType"
                >
                    <template scope="scope">
                        <span v-if="scope.row.orderWay == '0'">按月</span>
                        <span v-if="scope.row.orderWay == '1'">按次</span>
                    </template>
                </el-table-column>
                <el-table-column label="就餐情况" align="center" prop="istake">
                    <template scope="scope">
                        <span v-if="scope.row.istake == '0'">未完成</span>
                        <span v-if="scope.row.istake == '1'">完成</span>
                        <span v-if="scope.row.istake == '2'">送餐中</span>
                    </template>
                </el-table-column>
                <el-table-column
                    label="金额"
                    align="center"
                    prop="orderMoney"
                ></el-table-column>
                <el-table-column
                    label="取餐方式"
                    align="center"
                    prop="orderWay"
                >
                    <template scope="scope">
                        <span v-if="scope.row.orderWay == '0'">送餐</span>
                        <span v-if="scope.row.orderWay == '1'">堂食</span>
                        <span v-if="scope.row.orderWay == '2'">自取</span>
                    </template>
                </el-table-column>
            </el-table>

            <span slot="footer" class="dialog-footer">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="goLog" :loading="clickLoding"
                    >打印</el-button
                >
            </span>
        </el-dialog>
    </div>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            default: "订餐记录",
        },
        show: {
            type: Boolean,
            default: false,
        },
        datas: {
            type: Object,
            default: () => {
                return { table: [] }
            },
        },
    },
    data() {
        return {
            clickLoding: false,
        }
    },
    methods: {
        cancel() {
            this.$parent.dc_records_close()
        },
        goLog() {
            this.clickLoding = true
            this.$print(this.$refs["dc_records_table"])
            setTimeout(() => {
                this.clickLoding = false
            }, 3000)
        },
    },
    mounted() {},
}
</script>

<style scoped>
.dcDialog {
    width: 50%;
}
</style>